import React from "react"
import { matchPath, Navigate, Route, Routes, useLocation } from "react-router-dom"
import Intro from "../Intro"
import RoutePath from './RoutePathDefinition'

var MatchPathFromPathArray =(pathname, candidate_path_array)=>{
  for(var i=0;i<candidate_path_array.length;++i){
    if (matchPath(candidate_path_array[i], pathname) !==null){
      return i
    }
  }

  return undefined
}

const RouteRoot=()=>{
  const location =useLocation()

  return (
    <React.StrictMode>
      <Routes key={location.pathname} location={location}>
        <Route path={RoutePath.ROOT.path}>
          <Route path={RoutePath.INTRO.path} element={<Intro/>}/>

          <Route path='*' element={<Navigate to='/' replace={true}/>}/>
        </Route>
      </Routes>
    </React.StrictMode>
  )
}

export default {
  RouteRoot,
  MatchPathFromPathArray,
}